import isEqual from "lodash.isequal"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import { createActions, createReducer } from "reduxsauce"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getRequestsVerifiInformRequest: ["payload"], // payload: { params }
  getRequestsVerifiInformSuccess: ["payload"], // payload: { data }

  requestsVerifiInformFailure: ["payload"], // payload: { errors }

  clearRequestsVerifiInformFilters: null,
  requestsVerifiInformSetProp: ["key", "value"],

  getRequestVerifiInformRequest: ["payload"], // payload: { id }
  getRequestVerifiInformSuccess: ["payload"], // payload: { data }
  getRequestVerifiInformFailure: ["payload"], // payload: { errors }

  updateRequestVerifiInformStatusRequest: ["payload"], // payload: { id, status }
  updateRequestVerifiInformStatusSuccess: ["payload"], // payload: { data }
  updateRequestVerifiInformStatusFailure: ["payload"], // payload: { errors }

  logout: null
})

export const RequestsVerifiInformTypes = Types
export default Creators

/* ------------- Initial State ------------- */

const columnsAdmin = [
  { field_id: "created", label: "Request date", active: true },
  { field_id: "updated", label: "Update status date", active: true },
  { field_id: "ba_name", label: "Business account", active: true },
  { field_id: "user_name", label: "User name", active: true }
]

export const INITIAL_STATE = {
  fetching: false,
  result: {
    count: 0,
    next: null,
    previous: null,
    results: []
  },

  defaultColumnsAdmin: [...columnsAdmin],
  columnsAdmin: [...columnsAdmin],

  filtersLastUpd: null,
  filters: {
    request_date: null,
    status: [],
    business_account: [],
    user_name: []
  },

  visibleFiltersAdmin: { status: true, user_name: true },
  filterOptions: {
    status: ["pending", "successful", "rejected", "unenrolled"]
  },

  requestVerifiInform: null,
  requestVerifiInformFetching: false
}

/* ------------- Selectors ------------- */
export const selectAreFiltersDefault = (state) =>
  isEqual(state.requestsVerifiInform.filters, INITIAL_STATE.filters)

/* ------------- Functions for reducer cases ------------- */
const getRequestsVerifiInformRequest = (state) => ({
  ...state,
  fetching: true
})
const getRequestsVerifiInformSuccess = (state, { payload: result }) => {
  if (result.results) {
    return { ...state, fetching: false, result }
  } else {
    return {
      ...state,
      fetching: false,
      result: {
        count: result?.length || 0,
        results: result
      }
    }
  }
}

const requestsVerifiInformFailure = (state) => ({ ...state, fetching: false })

const getRequestVerifiInformRequest = (state) => {
  console.log("getRequestVerifiInformRequest reducer", {
    ...state,
    requestVerifiInform: null,
    requestVerifiInformFetching: true
  })
  return {
    ...state,
    requestVerifiInform: null,
    requestVerifiInformFetching: true
  }
}

const getRequestVerifiInformSuccess = (state, { payload: requestVerifiInform }) => ({
  ...state,
  requestVerifiInformFetching: false,
  requestVerifiInform
})

const getRequestVerifiInformFailure = (state) => ({
  ...state,
  requestVerifiInformFetching: false
})

const updateRequestVerifiInformStatusRequest = (state) => state
const updateRequestVerifiInformStatusSuccess = (state, { payload: { id, status, response } }) => {
  console.log(id, status, response)
  return {
    ...state,
    result: {
      ...state?.result,
      results: state?.result?.results?.map((item) => {
        if (item?.id === id) {
          return { ...item, status }
        }
        return item
      })
    }
  }
}
const updateRequestVerifiInformStatusFailure = (state) => state

export const requestsVerifiInformSetProp = (state, { key, value }) => {
  const obj = {}
  if (["filters", "visibleFilters", "visibleFiltersAdmin"]?.includes(key)) {
    if (key === "filters") obj.filtersLastUpd = new Date().getTime()
    obj[key] = { ...state?.[key], ...value }
  } else {
    obj[key] = value
  }
  return { ...state, ...obj }
}

export const clearRequestsVerifiInformFilters = (state) => {
  return { ...state, filters: INITIAL_STATE.filters }
}

const logout = (state) => {
  return {
    ...INITIAL_STATE,
    filters: state.filters,
    columnsAdmin: state.columnsAdmin,
    visibleFiltersAdmin: state.visibleFiltersAdmin
  }
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_REQUESTS_VERIFI_INFORM_REQUEST]: getRequestsVerifiInformRequest,
  [Types.GET_REQUESTS_VERIFI_INFORM_SUCCESS]: getRequestsVerifiInformSuccess,
  [Types.REQUESTS_VERIFI_INFORM_FAILURE]: requestsVerifiInformFailure,

  [Types.GET_REQUEST_VERIFI_INFORM_REQUEST]: getRequestVerifiInformRequest,
  [Types.GET_REQUEST_VERIFI_INFORM_SUCCESS]: getRequestVerifiInformSuccess,
  [Types.GET_REQUEST_VERIFI_INFORM_FAILURE]: getRequestVerifiInformFailure,

  [Types.UPDATE_REQUEST_VERIFI_INFORM_STATUS_REQUEST]: updateRequestVerifiInformStatusRequest,
  [Types.UPDATE_REQUEST_VERIFI_INFORM_STATUS_SUCCESS]: updateRequestVerifiInformStatusSuccess,
  [Types.UPDATE_REQUEST_VERIFI_INFORM_STATUS_FAILURE]: updateRequestVerifiInformStatusFailure,

  [Types.CLEAR_REQUESTS_VERIFI_INFORM_FILTERS]: clearRequestsVerifiInformFilters,

  [Types.REQUESTS_VERIFI_INFORM_SET_PROP]: requestsVerifiInformSetProp,

  [Types.LOGOUT]: logout
})

const PERSISTED_REDUCER_VERSION = 1;

export const persistedReducer = persistReducer(
  {
    key: "requestsVerifiInform",
    storage,
    whitelist: ["filters", "visibleFiltersAdmin"],
    version: PERSISTED_REDUCER_VERSION,
    migrate: async (state) => {
      if (state?._persist?.version < PERSISTED_REDUCER_VERSION) {
        return {
          ...state,
          visibleFiltersAdmin: INITIAL_STATE.visibleFiltersAdmin
        }
      }
      return state
    }
  },
  reducer
)
